__turbopack_context__.v({
  "active": "SecondaryNav-module__B-XOyG__active",
  "content": "SecondaryNav-module__B-XOyG__content",
  "contentMobile": "SecondaryNav-module__B-XOyG__contentMobile",
  "fadeIn": "SecondaryNav-module__B-XOyG__fadeIn",
  "mobileNav": "SecondaryNav-module__B-XOyG__mobileNav",
  "mobileNavColumn": "SecondaryNav-module__B-XOyG__mobileNavColumn",
  "mobileNavExpand": "SecondaryNav-module__B-XOyG__mobileNavExpand",
  "mobileNavItem": "SecondaryNav-module__B-XOyG__mobileNavItem",
  "nav": "SecondaryNav-module__B-XOyG__nav",
  "navItem": "SecondaryNav-module__B-XOyG__navItem",
  "root": "SecondaryNav-module__B-XOyG__root",
  "sectionTitleVisible": "SecondaryNav-module__B-XOyG__sectionTitleVisible",
});
